import React from 'react'

import IFace from '../ViewerIFace'

import { getEmailName, getUserEmail, getUserDomain, isEmail, uiInfo } from './utils'
import type { FileIconState } from './utils'
import { getDisplayEmailElem, getDisplayNameElem, getEmailOptionElem } from './uiHelpers'

export { getEmailName, setUserEmail, getUserEmail, getUserDomain, isEmail } from './utils'
export type { FileIconState } from './utils'
export { getDisplayEmailElem, getDisplayNameElem, getEmailOptionElem } from './uiHelpers'

interface EmailOptions {
  name?: string | null
  email?: string | null
  endStr?: string
  key?: string | number
  avatar?: React.ReactNode
}

interface FileIconResult {
  url?: string
  type?: string
  data?: string
  showExt?: boolean
}

export function processEmailEvent(e?: React.MouseEvent): void {
  if (e != null) {
    const emailElem = (e.target as HTMLElement).closest('.emailSet[data-email]')
    if (emailElem != null) {
      const email = emailElem.getAttribute('data-email')
      const name = emailElem.getAttribute('data-name')
      IFace.WebToNative.showContact(email, name)

      e.preventDefault()
      e.stopPropagation()
      return
    }
  }
}

export function getDisplayEmailStr(options: EmailOptions): string {
  const { name, email } = options
  if (isEmail(email) === true) {
    const domain = getUserDomain()

    if (email!.endsWith(domain!) === true) {
      return name || email!
    }

    if (name == null || name === email) {
      return email!
    }

    return `${name} <${email}>`
  } else if (name != null && (email == null || email.length === 0)) {
    return name
  }

  return email || ''
}

export function getDisplayEmailHTMLStr(options: EmailOptions): string {
  const { name, email } = options
  if (isEmail(email) === true) {
    const domain = getUserDomain()

    let text = ''
    if (email!.endsWith(domain!) === true) {
      text = name || email!
    } else if (name == null || name === email) {
      text = email!
    } else {
      text = `${name} &lt;${email}&gt;`
    }

    let propStr = `data-email="${email}"`
    if (name != null && name.length > 0) {
      propStr = `${propStr} data-name="${name}"`
    }

    return `<span class="emailSet" ${propStr}>${text}</span>`
  } else if (name != null && (email == null || email.length === 0)) {
    return name
  }

  return email || ''
}

export async function getFileIcon(fName?: string): Promise<FileIconState> {
  const fileName = fName || ''
  if (uiInfo.fileIconMap == null) {
    uiInfo.fileIconMap = {}
  }

  if (uiInfo.fileIconMap[fileName] == null) {
    const pos = fileName.lastIndexOf('.')
    const ext = fileName.substring(pos + 1)

    const ret = (await IFace.WebToNative.getFileIcon(fileName)) as FileIconResult
    const { url, type, data, showExt } = ret
    const newState: FileIconState = {}
    if (url != null) {
      newState.imgSrc = url
      newState.alt = ext
    } else if (data != null && type != null) {
      const dataUrl = `data:${type};base64,${data}`
      newState.imgSrc = dataUrl
      newState.alt = ext
    }

    if (showExt === true || newState.imgSrc == null) {
      newState.text = ext
    }

    uiInfo.fileIconMap[fileName] = newState
  }

  return uiInfo.fileIconMap[fileName]
}

const helper = {
  getEmailName,
  getUserEmail,
  getUserDomain,
  processEmailEvent,
  getDisplayEmailStr,
  getDisplayEmailElem,
  getDisplayNameElem,
  getFileIcon,
  getEmailOptionElem,
  isEmail,
}

export default helper
